var scope_0 = require('/vercel/path1/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/10e8410e4b69f100b368c5658f2fe96d.js').default;
var scope_1 = require('/vercel/path1/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
var scope_2 = require('/vercel/path1/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/299e5e08bf7a75239f0b0e05134356bd.js').default;
var scope_3 = require('/vercel/path1/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/71ef5f77941bc310cdbf9671e6b7a26d.js').default;
var scope_4 = require('/vercel/path1/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/93a4c953799787646ef95dc4d40c5c89.js').default;
var scope_5 = require('/vercel/path1/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b2aeb36d24328853341eb9a4e4ae19d4.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5 )
    